import React from 'react';
import { observer } from 'mobx-react-lite';
import { GameBackside, GameHolder } from '@pascal/pascal-core/table-line';
import { GameContent } from '../../containers/gameContent';

export const WebGameMain = observer(() => {
  return (
    <GameHolder>
      <GameBackside />
      <GameContent />
    </GameHolder>
  );
});
